import styled from 'styled-components';

// An option's label followed by its icons, e.g. the preferred ribbon and the accepts-plan check.
export const OptionWithIcons = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  width: 100%;
`;

export const OptionIcons = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

// Legends in a field label's row, e.g. "Preferred Provider" and "Accepts {plan}".
export const LabelBadges = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const LabelBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
